module.exports = __webpack_public_path__ + "static/media/eli_capiluoto.404589ac.png";